import { Box, TableCell, type TableCellProps } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useTranslation } from 'react-i18next';

/**
 * The header of a table's action column (TMMAPP-0080, axe `empty-table-header`): the buttons in the
 * column have no visible heading, so the header carries a visually hidden "Actions" that a screen
 * reader announces with each cell.
 */
export function ActionsHeaderCell({ padding }: { padding?: TableCellProps['padding'] }) {
  const { t } = useTranslation();
  return (
    <TableCell padding={padding}>
      <Box component="span" sx={visuallyHidden}>
        {t('common.actions')}
      </Box>
    </TableCell>
  );
}
